<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑分类' : '新增分类'"
      :visible.sync="showAddOrEdit"
      width="600px"
      :before-close="cancelFun"
    >
      <el-form ref="form" :model="formData" label-width="100px">
        <el-form-item v-show="$route.query.showCategory" label="上级分类">
          <SelectGoodsCategory v-model="formData.parentId"></SelectGoodsCategory>
        </el-form-item>
        <el-form-item label="名称" prop="categoryName" :rules="rules">
          <el-input v-model="formData.categoryName" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="图标">
          <FileUpload :name.sync="formData.icon" :url="formData.iconUrl"></FileUpload>
        </el-form-item>
        <el-form-item label="排序" prop="sort" :rules="rules">
          <el-input v-model="formData.sort" placeholder="请输入" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="cancelFun">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SelectGoodsCategory from '@/views/components/select-goods-category.vue';
import FileUpload from '@/components/file-upload/index.vue';
import { addGoodsCategoryAPI, editGoodsCategoryAPI, getGoodsCategoryDetailAPI } from './api';

export default {
  name: 'GoodsCategoryAddOrEdit',
  components: { SelectGoodsCategory, FileUpload },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
    parentRowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      formData: {
        parentId: 0,
        categoryName: '',
        icon: '',
        iconUrl: '',
        sort: 1
      },
      pid: 0,
      isShow: false,
    }
  },
  mounted() {
    this.pid = this.rowId;
    if (this.rowId && this.$route.params.parentId === undefined) {
      this.getGoodsCategoryDetail();
    }
  },
  methods: {
    async getGoodsCategoryDetail() {
      const res = await getGoodsCategoryDetailAPI(this.rowId);
      this.pid = res.parentId;
      this.formData = res;
    },
    submitFun() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.formData.parentId == null) this.formData.parentId = 0;
          if (this.formData.id) {
            editGoodsCategoryAPI(this.formData).then(() => {
              this.$message.success('编辑成功');
              this.$emit("closeDialog", true);
            })
          } else {
            // 新增分两种，$route.params中有id时为新增子级，无则为新增一级
            if (this.rowId) {
              this.formData.parentId = this.rowId;
              addGoodsCategoryAPI(this.formData).then(() => {
                this.$message.success('新增成功');
                this.$emit("closeDialog", true);
              })
            } else {
              addGoodsCategoryAPI(this.formData).then(() => {
                this.$message.success('新增成功');
                this.$emit("closeDialog", true);
              })
            }
          }
        }
      })
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .el-form {
    .el-form-item {
      .el-input {
        width: 300px;
      }
    }
  }
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
}
</style>
